import { useLayouts, useDictionary, useClient } from "@adamlip/okeoke.client";
import {
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
  SelectSection,
  Modal,
  ModalBody,
  ModalContent,
  Button,
} from "@nextui-org/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CurrentOpenHours from "views/Locations/CurrentOpenHours";

export default function MapLayouts() {
  const { setSelectedLocation, locations } = useClient();
  const navigate = useNavigate();

  const { layouts } = useLayouts();
  const { getValue } = useDictionary();

  const [selectedLayout, setSelectedLayout] = useState("");
  const [groups, setGroups] = useState([]);
  const [locationModalOpen, setLocationModalOpen] = useState(false);

  const colors = {
    1: "text-[#f5a524]",
    2: "text-[#f31260]",
  };

  const handleClick = () => {
    if (layouts?.[selectedLayout]?.meta?.locationUUID) {
      setLocationModalOpen(true);
    }
  };

  const handleClickLocation = () => {
    setLocationModalOpen(false);
    setSelectedLocation(layouts?.[selectedLayout]?.meta?.locationUUID);
    navigate("/order");
  };

  useEffect(() => {
    if (layouts) {
      let groups = [
        ...new Set(
          Object.values(layouts || {})
            .filter((layout) => layout.layoutType === "map")
            .map((layout) => layout.meta.group)
        ),
      ];
      setGroups(groups.sort((a, b) => (a > b ? 1 : -1)));
    }
  }, [layouts]);

  return (
    <>
      <div className="h-full overflow-auto pb-[20vh]">
        <div className="mt-2 font-bold text-xl text-center h-[28px]">
          {getValue("app_v2_map_layout_title")}
        </div>
        <div className="h-[60px] flex justify-center mb-2">
          <Select
            aria-label="12"
            label={getValue("app_v2_select_zone")}
            selectedKeys={selectedLayout !== "" ? [selectedLayout] : []}
            onSelectionChange={(e) => {
              const array = Array.from(e);
              setSelectedLayout(array[0] || "");
            }}
            className="w-[90%] m-auto"
          >
            {groups.map((group) => (
              <SelectSection key={group} showDivider title={group}>
                {Object.values(layouts || {})
                  .filter((layout) => layout?.meta?.group === group)
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((layout) => (
                    <SelectItem
                      key={layout.uuid}
                      textValue={layout?.name}
                      aria-label="34"
                    >
                      <span
                        className={`${colors?.[
                          locations?.[layout?.meta?.locationUUID]
                            ?.extendedPrepTime?.reason
                        ] || "text-[#17c964]"
                          }`}
                      >
                        {layout?.name}
                      </span>
                    </SelectItem>
                  ))}
              </SelectSection>
            ))}
          </Select>
        </div>
        <div className={`h-[calc(100vh-260px)]`} onClick={() => handleClick()}>
          <img
            alt="img"
            className="object-contain"
            style={{ width: "100%", height: "100%" }}
            src={`${layouts?.[selectedLayout]?.meta?.background ||
              "https://cdn.okeoke.io/brands/PNRVqVMRU/brand-app-img/mainmap.png"
              }`}
          />
        </div>
      </div>
      <Modal
        isOpen={locationModalOpen}
        onOpenChange={() => setLocationModalOpen(!locationModalOpen)}
        size="l"
        scrollBehavior="inside"
        classNames={{
          closeButton:
            "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
        }}
      >
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="p-0">
                <div
                  className={`absolute top-0 w-full h-6 z-10 text-center`}
                  style={{
                    background:
                      locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                        ?.extendedPrepTime?.reason == null
                        ? "linear-gradient(180deg, rgba(23,201,100,1) 0%, rgba(255,255,255,0) 100%)"
                        : locations?.[
                          layouts?.[selectedLayout]?.meta?.locationUUID
                        ]?.extendedPrepTime?.reason === 1
                          ? "linear-gradient(180deg, rgba(245,165,36,1) 0%, rgba(255,255,255,0) 100%)"
                          : locations?.[
                            layouts?.[selectedLayout]?.meta?.locationUUID
                          ]?.extendedPrepTime?.reason === 2
                            ? "linear-gradient(180deg, rgba(243,18,96,1) 0%, rgba(255,255,255,0) 100%)"
                            : "linear-gradient(180deg, rgba(23,201,100,1) 0%, rgba(255,255,255,0) 100%)",
                  }}
                ></div>
                <div
                  className={`absolute top-0 left-[50%] translate-x-[-50%] px-2 w-f h-6 z-10 bg-white text-black text-center`}
                  style={{
                    borderBottomLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                >
                  {locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                    ?.extendedPrepTime?.reason == null &&
                    getValue("app_v2_location_prep_normal")}
                  {locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                    ?.extendedPrepTime?.reason === 1 &&
                    getValue("app_v2_location_prep_heavy")}
                  {locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                    ?.extendedPrepTime?.reason === 2 &&
                    getValue("app_v2_location_prep_extreme")}
                </div>
                <div className="relative">
                  <img
                    alt="map"
                    src={"https://cdn.okeoke.io/globalAsset/backgrounds/cafe"}
                  />
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="font-bold text-lg">
                  {
                    locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                      ?.name
                  }
                </div>
                <div className="">
                  {`${layouts?.[selectedLayout]?.meta?.group} ${layouts?.[selectedLayout]?.name}`}
                </div>
                <CurrentOpenHours
                  location={
                    locations?.[layouts?.[selectedLayout]?.meta?.locationUUID]
                  }
                />
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => handleClickLocation()}>
                  {getValue("app_v2_go_to_location")}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
